import React, { memo } from 'react';
import { Transition } from '@headlessui/react';
import { useAtomValue } from 'jotai';
import { orgOnboardingStepAtom, OrgOnboardingSteps } from '../use-organization-onboarding';

/**
 * Step container for Organization Onboarding flow.
 * Shows/hides step content with animation based on current step.
 * Mirrors the pattern from JP onboarding StepContainer.
 */
const OrgStepContainer = memo(function OrgStepContainer({
  children,
  stepKey,
}: {
  children: React.ReactNode;
  stepKey: OrgOnboardingSteps;
}) {
  const currentStep = useAtomValue(orgOnboardingStepAtom);

  // Callback ref to scroll to top when step is mounted
  const containerRef = React.useCallback(
    (node: HTMLDivElement | null) => {
      if (node && currentStep === stepKey) {
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }, 0);
      }
    },
    [currentStep, stepKey]
  );

  return (
    <React.Suspense fallback={<></>}>
      <Transition
        show={currentStep === stepKey}
        enter="transition-opacity duration-300 ease-in-out"
        enterFrom="opacity-0"
        enterTo="opacity-100"
      >
        <div ref={containerRef} className="w-full">
          {children}
        </div>
      </Transition>
    </React.Suspense>
  );
});

export default OrgStepContainer;
